import { SeedPlanInfo, SeedsDatalayer } from "./seedsDatalayer"
import { IDataLayerZone } from "../exports"
import { SeedRateUnit } from "../generated/enums"
import { DatalayerZone } from "@omnia/shared/layers/datalayerZone"
import { isDefined } from "@omnia/shared/utils/utils"

export class SeedsDatalayerZone extends DatalayerZone {

    private _seedRate: number


    constructor(
        private readonly seedsLayer: SeedsDatalayer,
        zone: IDataLayerZone,
        readonly plan: SeedPlanInfo,
        readonly planUnit = plan.planUnit,
        readonly kgHa = planUnit.unit === SeedRateUnit.Kg,
        /** If true, show rates in kg/ha, converting if necessary */
        readonly showRateInPlanUnit = !kgHa,
        readonly showRateInKgHa = kgHa && seedsLayer.supportsSeedRatesConversion(),
        /** If true, a rate in seeds/m² will also be displayed in map tooltips */
        readonly showRateInSeedsM2 = showRateInKgHa && (!seedsLayer.planHasFlatRate),

    ) {
        super(seedsLayer, zone)
    }

    supportsSeedRatesConversion(): boolean {
        return this.seedsLayer.supportsSeedRatesConversion()
    }
    get useFlatRate() {
        return this.seedsLayer.useFlatRate
    }

    get seedRateLabel() {
        const { planUnit , value } = this
        return `${value} ${planUnit.labels.rate}`
    }

    get seedRateSeedsM2() {
        return this.value as number
    }

    get seedRate(): number {
        const { _seedRate } = this
        if (isDefined(_seedRate)) return _seedRate
        return this.seedsLayer.convertSeedRatesToKg(this._value)
    }

    set seedRate(value: number) {
        this._seedRate = value
        this.value = this.seedsLayer.convertSeedRatesFromKg(value)
    }

}
